import type { LanguageId, UserId } from '@previo/codebooks'
import type { EmployeeInfo, Salesman, User as UserData, UserTypeId } from '~/http/user/User'

export class User {
  constructor(
    public readonly id: UserId | null,
    public readonly userTypeId: UserTypeId | null,
    public readonly userName: string,
    public readonly email: string,
    public readonly languageId: LanguageId | null,
    public readonly salesman: Salesman | null,
    public readonly employee: EmployeeInfo | null,
  ) {}

  static fromResponseData(data: UserData): User {
    return new User(
      data.id,
      data.userTypeId,
      data.userName,
      data.email,
      data.languageId,
      data.salesman,
      data.employee,
    )
  }

  static empty(): User {
    return new User(null, null, '', '', null, null, null)
  }
}
